import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { List } from 'immutable';
import { Adjustment } from '../models/adjustment';
import { AdjustmentHttpService } from './adjustment.http.service';
import { FlashMessagesService } from '../../shared/flash-messages/service/flash.messages.service';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { ReservationStore } from './reservation-store';
import { ReservationStatusCode } from '../models/reservation-status-code.enum';

@Injectable()
export class AdjustmentStore {
  private adjustmentList: ReplaySubject<List<Adjustment>> = new ReplaySubject<List<Adjustment>>(1);

  constructor(
    private adjustmentHttpService: AdjustmentHttpService,
    private flashMessagesService: FlashMessagesService,
    private reservationStore: ReservationStore
  ) {}

  addAdjustment(adjustment: Adjustment): Observable<any> {
    return this.adjustmentHttpService.addAdjustment(adjustment)
      .catch(error => {
        this.flashMessagesService.error('MESSAGES.ERROR.ADD_ADJUSTMENT', `Error adding adjustment: ${error}`);
        return Observable.throw(error);
      });
  }

  get adjustments(): Observable<List<Adjustment>> {
    return this.adjustmentList.asObservable();
  }

  loadAdjustments(eventId: number): Observable<List<Adjustment>> {
    return this.adjustmentHttpService.getAdjustments(eventId)
      .catch(error => {
        this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_PAYMENTS', `Error getting adjustments: ${error}`);
        return Observable.throw(error);
      })
      .map((result: List<Adjustment>) => {
        const sortedIterable = result.sort(
          (adjustment1, adjustment2) => {
            if (adjustment1.createdDate < adjustment2.createdDate) {
              return -1;
            } else if (adjustment1.createdDate > adjustment2.createdDate) {
              return 1;
            } else {
              return 0;
            }
          });
        this.adjustmentList.next(sortedIterable.toList());
        return result;
      });
  }

  deleteAdjustment(adjustmentId: number, eventId: number): Observable<any> {
    return this.adjustmentHttpService.deleteAdjustment(adjustmentId)
      .catch((error: any) => {
        this.flashMessagesService.error('MESSAGES.ERROR.DELETE_ADJUSTMENT', `Error deleting adjustment: ${error}`);
        return Observable.of(error);
      })
      .map(res => {
        this.loadAdjustments(eventId).subscribe();
        return res;
      });
  }

  getCalculatedPayment(reservationStatusCode: ReservationStatusCode): Observable<number> {
    let totalCommissions = 0;
    return this.reservationStore.getTotalCommissions(reservationStatusCode).flatMap(total => {
      totalCommissions = total;
      return this.adjustments;
    }).map((list: List<Adjustment>) => {
      const adjustmentTotal = list.reduce((sum: number, adjustment: Adjustment) => {
        return sum + adjustment.adjustmentAmount;
      }, 0);
      return adjustmentTotal + totalCommissions;
    });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/adjustment.store.ts